import React, { forwardRef, useEffect, useState } from 'react';
import {
    CarDetailsType,
    GalleryBucket,
    vehicle3DFramesResponse,
} from '@/types';
import BlinkingSkeleton from '../../../shared/blinking-skeleton/blinking-skeleton.component';
import { Gallery } from '../Gallery';
import myImageLoader from '@/image.local.loader';
import { CarTypesEnum, getCarType } from '../../car-type';

const CarGallery = forwardRef<
    HTMLDivElement,
    {
        carDetails: CarDetailsType;
        className?: string;
        IS_DESKTOP: boolean;
        framesWidth: number;
        framesHeight: number;
        imprefections3d: vehicle3DFramesResponse[];
        fireEvent: () => void;
        shouldRenderModals: boolean;
    }
>(
    (
        {
            carDetails,
            className,
            IS_DESKTOP,
            framesWidth,
            framesHeight,
            imprefections3d,
            fireEvent,
            shouldRenderModals,
        },
        ref
    ) => {
        const carType = getCarType(carDetails);
        return (
            <div ref={ref} className={`${className} grid-area-img`}>
                <GalleryWrapper
                    shouldRenderModals={shouldRenderModals}
                    buckets={carDetails.gallery.gallery}
                    images={(
                        carDetails?.frames ||
                        carDetails?.images ||
                        []
                    ).map(imgUrl =>
                        myImageLoader({
                            src: imgUrl,
                            width: framesWidth,
                            height: framesHeight,
                            quality: 95,
                        })
                    )}
                    imperfections={imprefections3d}
                    fireEvent={fireEvent}
                    interior3d={carDetails?.interior3d}
                    className={'max-md:-mx-[5%] max-md:w-svw'}
                    altImageText={`${carDetails?.make} ${carDetails?.model} ${carDetails?.year}`}
                    IS_DESKTOP={IS_DESKTOP}
                    carType={carType}
                />
            </div>
        );
    }
);

CarGallery.displayName = 'CarGallery';
export default CarGallery;

function GalleryWrapper(props: {
    shouldRenderModals: boolean;
    buckets: GalleryBucket[];
    images: any[];
    imperfections: vehicle3DFramesResponse[];
    fireEvent: () => void;
    interior3d: string;
    className: string;
    altImageText: string;
    IS_DESKTOP: boolean;
    carType: CarTypesEnum;
}) {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        const id = requestAnimationFrame(() => setIsMounted(true));
        return () => cancelAnimationFrame(id);
    }, []);

    if (!isMounted) {
        return (
            <BlinkingSkeleton
                height={props.IS_DESKTOP ? '50vw' : '40vw'}
                minHeight={props.IS_DESKTOP ? '45vw' : '50vh'}
            />
        );
    }

    return <Gallery {...props} />;
}
